export const PAYMENT_PROJECTS_LIST = [
  // Add project IDs here that have outstanding invoices
];
